import React, { Component } from 'react'
import { connect } from 'react-redux'

export class OurPartners extends Component {
    render() {
        return (
            <div id="partner" className="jumbotron shadow m-4 sec-width mx-auto bg-color-white">
                <div className="mx-3 antic">
                    <h1 className="heading-font bg-color-heading">Our Partners</h1>
                    <p className="body-font mt-3">Here at BPL, we know we're better together which is why we're proud to partner with these organizations:</p>
                    {/* <div className="w-100 d-flex align-items-center">
                        <img className="mx-auto" src="Images/Josef_logo.png" />
                    </div> */}
                    <div className="w-100 d-flex align-tems-center mt-3">
                        <img className="mx-auto w-75" src="Images/Checkbox _logo.png" />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(OurPartners)

